<mat-dialog-content>
  {{ data.message }}
</mat-dialog-content>
<mat-dialog-actions align="end">
<button mat-button [mat-dialog-close]="false">{{ 'common.no' | translate }}</button>
<button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ 'common.yes' | translate }}</button>
</mat-dialog-actions>
